<div class="ui-container">
  <ng-content></ng-content>
</div>
